import Vue from "vue";
import Router from "vue-router";
const Index = () =>
  import(/* webpackChunkName: "group-index" */ "../views/index.vue");
const Product = () =>
  import(/* webpackChunkName: "group-index" */ "../views/product.vue");
const Product_1 = () =>
  import(/* webpackChunkName: "group-index" */ "../views/product/1.vue");
const Product_2 = () =>
  import(/* webpackChunkName: "group-index" */ "../views/product/2.vue");
const Product_3 = () =>
  import(/* webpackChunkName: "group-index" */ "../views/product/3.vue");
const About = () =>
  import(/* webpackChunkName: "group-index" */ "../views/about.vue");
const Contact = () =>
  import(/* webpackChunkName: "group-index" */ "../views/contact.vue");
const Cookie = () =>
  import(/* webpackChunkName: "group-index" */ "../views/cookie.vue");
const Legal = () =>
  import(/* webpackChunkName: "group-index" */ "../views/legal.vue");
const Disclosure = () =>
  import(/* webpackChunkName: "group-index" */ "../views/disclosure.vue");
const Notice = () =>
  import(/* webpackChunkName: "group-index" */ "../views/notice.vue");

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: { title: "首页-安世联合保险经纪有限公司" }
    },
    {
      path: "/product",
      name: "product",
      component: Product,
      meta: { title: "产品服务-安世联合保险经纪有限公司" }
    },
    {
      path: "/product/1",
      name: "product_1",
      component: Product_1,
      meta: { title: "产品服务-安世联合保险经纪有限公司" }
    },
    {
      path: "/product/2",
      name: "product_2",
      component: Product_2,
      meta: { title: "产品服务-安世联合保险经纪有限公司" }
    },
    {
      path: "/product/3",
      name: "product_3",
      component: Product_3,
      meta: { title: "产品服务-安世联合保险经纪有限公司" }
    },
    {
      path: "/about",
      name: "about",
      component: About,
      meta: { title: "关于我们-安世联合保险经纪有限公司" }
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      meta: { title: "联系我们-安世联合保险经纪有限公司" }
    },
    {
      path: "/cookie",
      name: "cookie",
      component: Cookie,
      meta: { title: "隐私政策-安世联合保险经纪有限公司" }
    },
    {
      path: "/legal",
      name: "legal",
      component: Legal,
      meta: { title: "法律声明-安世联合保险经纪有限公司" }
    },
    {
      path: "/disclosure",
      name: "disclosure",
      component: Disclosure,
      meta: { title: "信息披露-安世联合保险经纪有限公司" }
    },
    {
      path: "/notice",
      name: "notice",
      component: Notice,
      meta: { title: "通知公告-安世联合保险经纪有限公司" }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js